export default {
      id: "tropical-plants-usage",
      viewBox: "0 0 45 33",
      url: __webpack_public_path__ + "img/icons.svg#tropical-plants",
      toString: function () {
        return this.url;
      }
    }